export default __webpack_public_path__ + "static/figure-35c61f1e7193ae7ba70c3afeb932b027.png";